import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { checkRowText } from '../../billMemory/client';
import { shortDate } from '../../billMemory/core';
import RevertLineButton from './RevertLineButton';

/**
 * Recent greens (Fix plan, I2): the rows Bill Memory filled in the last 14 days. "This was wrong" on any of them
 * counts it as a wrong green and corrects what was learned (a name learned once is forgotten; a trusted one is
 * asked about again), then offers to revert that line (I4). Owner and Managers (the server enforces it).
 */
export default function RecentGreens() {
  const [rows, setRows] = useState(null);
  const [done, setDone] = useState({}); // line_id → { revert } | { error }
  useEffect(() => {
    Promise.resolve(api.getRecentGreens()).then((r) => setRows((r && r.rows) || [])).catch(() => setRows([]));
  }, []);
  const wrong = async (r) => {
    try {
      const out = await api.markLineWrong(r.line_id, null);
      setDone((d) => ({ ...d, [r.line_id]: { revert: out && out.revert } }));
    } catch (e) {
      setDone((d) => ({ ...d, [r.line_id]: { error: (e && e.message) || 'That was refused.' } }));
    }
  };
  if (!rows) return <div className="bm-note">Loading…</div>;
  if (!rows.length) return <div className="bm-note">Bill Memory has not filled any row in the last 14 days.</div>;
  return (
    <ul className="bm-log">
      {rows.map((r) => {
        const d = done[r.line_id];
        return (
          <li key={r.line_id}>
            <div>{`${r.saved_at ? `${shortDate(r.saved_at)}: ` : ''}${checkRowText(r)}`}</div>
            {!d || d.error ? (
              <span>
                <button type="button" className="irr-secondary-btn" onClick={() => wrong(r)}>This was wrong</button>
                {d && d.error && <span className="bm-note">{` ${d.error}`}</span>}
              </span>
            ) : (
              <span>
                <span className="bm-note">Marked wrong. </span>
                <RevertLineButton revert={d.revert} />
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
